import { FC } from 'react'
import { GiftGiversProvider, useGiftGivers } from './context/GiftGiversProvider'

interface GiftTrackerRevampRouteProps {
  registryId: number | string | undefined
}

const LogBody: FC = () => {
  const { isLoading, isFetched, giftGivers } = useGiftGivers()

  const content = `
    isLoading: ${isLoading}
    isFetched: ${isFetched}
    # giftGivers: ${Object.keys(giftGivers || {}).length}
    giftGivers: ${JSON.stringify(giftGivers, null, 2)}
  `
  return <pre>{content}</pre>
}

const GiftTrackerRevampRoute: FC<GiftTrackerRevampRouteProps> = ({
  registryId,
}) => (
  <GiftGiversProvider registryId={registryId}>
    <LogBody />
  </GiftGiversProvider>
)

export default GiftTrackerRevampRoute
